
import Vue from "vue";
import { Company } from "@/models/company";
import { Dossier } from "@/models/dossier";
import { Script } from "@/models/script";
import { CompanyService } from "@/services/company-service";
import { CompanyDossierService } from "@/services/company-dossier-service";
import { ScriptService } from "@/services/script-service";
import "codemirror/mode/javascript/javascript";
import AppDossierScriptEditProperties from "@/components/dossier/DossierScriptEditProperties.vue";
import { downloadBlob } from "@/utils/blob";
import AppDossierScriptEditUpload from "@/components/dossier/DossierScriptEditUpload.vue";

export default Vue.extend({
	data(){
		return {
			company: new Company(),
			dossier: new Dossier(),
			script: new Script(),
			ready: false,
			propertiesModal: false,
			uploadModalOpen: false
		};
	},
	computed: {
		cmOptions():any{
			return {
				mode: "text/javascript"
			};
		},
		info():string | null {
			if (this.script.ScriptType == "axios-on-request-interceptor"){
				return `Parameters:
				req:InternalAxiosRequestConfig
				axios:AxiosInstance
				services:Object met alle app services`;
			}
			if (this.script.ScriptType == "axios-on-response-interceptor"){
				return `Parameters:
				req:AxiosResponse
				axios:AxiosInstance
				services:Object met alle app services`;
			}
			return null;
		}
	},
	methods: {
		goToScripts(){
			this.$router.push(`/companies/${this.company.id}/dossier/${this.dossier.id}/edit`);
		},
		async save(){
			if (this.script.ID == 0){
				this.script = await ScriptService.createScript(this.dossier.id, this.script);
			}else{
				this.script = await ScriptService.updateScript(this.dossier.id, this.script);
			}
			this.$wf.notify("Changes saved", "success", 3000, "check");
		},
		editProperties(){
			this.propertiesModal = true;
		},
		downloadScript(){
			let script = new Script(this.script.getJSON());
			script.ID = 0;
			script.LastEditedBy = "";
			script.CreatedBy = "";
			let content = JSON.stringify(script.getJSON());
			let blob = new Blob([content], {type: "application/json"});
			downloadBlob(blob, "script.json");
		},
		onFileUploadResult(script:Script){
			script.ID = this.script.ID;
			script.LastEditedBy = this.script.LastEditedBy;
			script.CreatedBy = this.script.CreatedBy;
			this.script = script;
		}
	},
	async created(){
		let companyId = parseInt(this.$route.params.companyId);
		let dossierId = parseInt(this.$route.params.dossierId);
		this.company = await CompanyService.getCompany(companyId);
		this.dossier = await CompanyDossierService.getDossier(companyId, dossierId);
		let scriptId = parseInt(this.$route.params.scriptId || "0");
		if (scriptId != 0){
			this.script = await ScriptService.getScript(this.dossier.id, scriptId);
		}
		this.ready = true;
	},
	components: {
		AppDossierScriptEditProperties,
		AppDossierScriptEditUpload
	}
});
